import MyAssignmentOfferExcerpt from '@/components/MyAssignmentOfferExcerpt/MyAssignmentOfferExcerpt.vue';

export default {
    components: {
        MyAssignmentOfferExcerpt,
    },
};
